import { CbhFeatureFlag } from "../../../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../../../FeatureFlags/useCbhFlag";

export function useIsShiftRecommendationsEnabled() {
  return useCbhFlag(CbhFeatureFlag.HACK_WEEK_SHIFT_RECOMMENDATIONS, {
    defaultValue: false,
  });
}
